import React from "react";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";

const NoAccess = () => {
  return (
    <div className="flex justify-center items-center h-full-screen w-full">
      <div className="flex-column justify-center items-center">
        <img className="mb-8 w-full" src="/public/assets/images/illustrations/403.png" alt="" style={{ width: 600, height: 600 }} />
        <p>Нет доступа</p>
        <Link to="/">
          <Button variant="contained" color="primary" size="large">
            Вернуться на главную
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default NoAccess;
